export default __webpack_public_path__ + "static/media/Apartament Codruta_33-min.2049213d.jpg";